import { useContext, useMemo } from 'react'

import { useSelector } from 'react-redux'
import { faEdit, faIdBadge } from '@fortawesome/pro-solid-svg-icons'

import DataTable from '../../../../Components/antd/Tables/DataTable/DataTable'
import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import { BadgeAssignation, getters, TERMINATED } from '../../../../utils/entities/badge'
import { Action, DeleteAction } from '../../../../Components/antd/Tables/DataTable/utils/actions'
import BadgeFilters from './BadgeFilters'
import { BadgeAssignationContext, Modes } from '../../../../Providers/Badge/BadgeAssignationProvider/BadgeAssignationProvider'
import moment from 'moment'
import { OrderBy } from '../../../../utils/constants'

const BadgesTable = ({ data, loading, metadata, parameters, onChange, onDelete, onFiltersChange, onParametersChange }) => {
  const { setContext } = useContext(BadgeAssignationContext)

  const t = useSelector(selectTranslate)

  const columns = useMemo(() => [
    { title: t('column_title.badge_number'), orderBy: OrderBy.BADGE_NUMBER, key: getters.badgeNumber },
    { title: t('column_title.rfid_number'), orderBy: OrderBy.RFID_NUMBER, key: getters.rfidNumber },
    { title: t('column_title.start_date'), orderBy: OrderBy.START_DATE, key: getters.stringStartDate },
    { title: t('column_title.end_date'), orderBy: OrderBy.END_DATE, key: getters.stringEndDate },
    { title: t('column_title.student'), orderBy: OrderBy.STUDENT, key: getters.student }
  ], [t])

  const actions = useMemo(() => [
    new Action({
      title: 'common.edit',
      icon: faEdit,
      onClick: badgeAssignation => setContext({ mode: Modes.MANAGE, data: new BadgeAssignation({ ...badgeAssignation, id: getters.badgeAssignationId(badgeAssignation) }), callback: onChange })
    }),
    new Action({
      disabled: b => getters.status(b) === TERMINATED,
      title: 'Recover this badge ?',
      icon: faIdBadge,
      onClick: badgeAssignation => setContext({ mode: Modes.RECOVERY, data: new BadgeAssignation({ ...badgeAssignation, id: getters.badgeAssignationId(badgeAssignation) }), callback: onChange })
    }),
    new DeleteAction({
      onDelete: onDelete,
      popconfirmTitle: 'Delete this assignation ?',
      title: 'Delete'
    })
  ], [onChange, onDelete])

  return (
    <DataTable
      actions={actions}
      columns={columns}
      data={data}
      filtersMenu={(<BadgeFilters filters={parameters.filters} onFiltersChange={onFiltersChange} />)}
      loading={loading}
      metadata={metadata}
      parameters={parameters}
      onCreate={() => setContext({ mode: Modes.MANAGE, data: new BadgeAssignation({ startDate: moment() }), callback: onChange })}
      onParametersChange={onParametersChange}
    />
  )
}

export default BadgesTable
